import React, { useState } from 'react';
import { Tabs as MuiTabs, Tab, Box } from '@mui/material';
import TabPanel from './TabPanel';
var Tabs = function (props) {
    var headers = props.headers, bodies = props.bodies, id = props.id, overflowPanelY = props.overflowPanelY, onChange = props.onChange;
    var _a = useState(0), value = _a[0], setValue = _a[1];
    var handleChange = function (evt, num) {
        setValue(num);
        if (onChange) {
            onChange(num);
        }
    };
    var renderHeaders = function () {
        return headers.map(function (header, idx) {
            return React.createElement(Tab, { label: header.label, key: "".concat(id, "-").concat(idx, "-head") });
        });
    };
    var renderBodies = function () {
        return bodies.map(function (body, idx) {
            return (React.createElement(TabPanel, { id: id, hidden: value !== idx, index: idx, key: "".concat(id, "-").concat(idx, "-body"), overflowY: overflowPanelY }, body));
        });
    };
    return (React.createElement(Box, { sx: { width: '100%' } },
        React.createElement(Box, { sx: { borderBottom: 1, borderColor: 'divider' } },
            React.createElement(MuiTabs, { value: value, onChange: handleChange, "aria-label": "basic tabs example" }, renderHeaders())),
        renderBodies()));
};
export default Tabs;
